module.exports = __webpack_public_path__ + "static/media/help_ptr.5236b599.ico";